export default class ProcessadorDeValor {
    constructor() {
        this.mapaProcessadores = {};
    }

    registrarProcessador(tipoCampo, tipoValor, processador) {
        if (!this.mapaProcessadores[tipoCampo]) {
            this.mapaProcessadores[tipoCampo] = {};
        }
        this.mapaProcessadores[tipoCampo][tipoValor] = processador;
    }

    processar(campo) {
        const processador =
            this.mapaProcessadores[campo.tipo]?.[
                campo.valor?.tipo || "default"
            ];

        if (processador) {
            return processador.processar(campo);
        }

        return campo?.valor || null;
    }
}
